<template>
    <div id="login">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="login-content d-flex row">
                        <div class="col-md-6 pr-0 order-1 order-md-0">
                            <div v-bind:style="{ backgroundImage: 'url(' + require('@/assets/images/banner-login.png') + ')' }" class="login-banner d-flex">
                                <div class="align-self-center">
                                    Wadah resmi alumni FBE UBAYA untuk membangun jejaring profesional, kolaborasi lintas generasi, dan kontribusi nyata bagi almamater serta masyarakat.
                                </div>
                            </div>
                        </div>
                        <div class="login-form col-md-6 order-0 order-md-1">
                            <h3>Ubah Kata Sandi</h3>
                            <p>Silakan masukkan password baru anda</p>
                            <br><br>
                            <form @submit.prevent="actionForgot()">
                                <input type="hidden" name="token" v-model="token">
                                <input type="hidden" name="email" v-model="email">
                                <input type="password" v-model="password" name="password" class="form-control" placeholder="Masukkan Password Anda">
                                <input type="password" v-model="password_confirm" name="password_confirm" class="form-control" placeholder="Masukkan Kembail Password Anda">
                                <button class="btn btn-primary fullsize-btn" :class="disable_submit">
                                    <span v-if="disable_submit == ''">Change Password</span>
                                    <b-spinner v-if="disable_submit == 'disabled'" label="Loading..." small />
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        name: 'Forgot',
        data () {
            return {
                token: this.$route.query.token,
                email: this.$route.query.email,
                password: '',
                password_confirm: '',
                disable_submit: ''
            }
        },
        methods: {
            async actionForgot () {
                this.disable_submit = 'disabled'
                const response = await axios.post('resetpassword', {
                    token: this.token,
                    email: this.email,
                    password: this.password,
                    confirm_password: this.password_confirm
                }).catch(e => e.error)

                if (response) {
                    if (response.data) {
                        this.disable_submit = ''
                        this.$swal(
                            'Success!',
                            'Your password has been change.',
                            'success'
                        ).then(() => {
                            this.$router.push('/login')
                        })
                    } else {
                        this.disable_submit = ''
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Ops an error occurred, make sure the password entered is the same!'
                        })
                    }
                } else {
                    this.disable_submit = ''
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Ops an error occurred'
                    })
                }
            }
        }
    }
</script>
